/**
 * 组态拥有者类型
 */
export var ConfigureOwnerType;
(function (ConfigureOwnerType) {
    /**
     * 设备模板
     */
    ConfigureOwnerType[ConfigureOwnerType["DeviceModel"] = 0] = "DeviceModel";
    /**
     * 非标设备
     */
    ConfigureOwnerType[ConfigureOwnerType["NonStandardDevice"] = 1] = "NonStandardDevice";
})(ConfigureOwnerType || (ConfigureOwnerType = {}));
